<!--提交对话框-->
<template>
    <el-dialog title="申请提交" :visible.sync="dialogVisible" width="500px" :before-close="_handleClose">
        <!-- 保存提示 -->
        <div class="tipList">
            <p>经推荐单位推荐，我单位确认申报本次项目，郑重承诺如下：</p>
            <p>一、我单位提交的资料齐全、真实、有效、不存在弄虚作假的现象</p>
            <p>
                二、我单位在参评过程中，坚决遵守相关规定，杜绝向评审有关人员发出宴请，赠送礼品、纪念品、现金、
                有价证券、支付凭证等，不组织旅游和与评选工作无关的参观活动。若有违背上述承诺，我单位愿意承担相应责任，
                按规定接受处罚，自愿放弃参评资格或取消荣誉称号。</p>
        </div>
        <span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">返回</el-button>
			<el-button type="primary" @click="_submit">确认提交</el-button>
		</span>
    </el-dialog>
</template>

<script>
    import {applySubmit} from "@/api/modules/project";

    export default {
        data() {
            return {
                dialogVisible: false,
                prjApplyID: ''
            }
        },
        methods: {
            showDialog(prjApplyID) {
                this.dialogVisible = true
                this.prjApplyID = prjApplyID;
            },
            //确认提交
            _submit() {
                //this.$confirm('确认提交?').then(()=>{})
               applySubmit({
                  data: {prjApplyId: this.prjApplyID},
                  success: (res) => {
                     this.$message.success("提交成功");
                     this._handleClose();
                     this.$emit("dialogClose");
                     /*绿色工程*/
                     if (localStorage.getItem('projectType') == 18)
                        this.$router.push('/index/greenEngineerApply/applyList')
                  }
               })
            },
            /*对话框关闭*/
            _handleClose() {
                this.dialogVisible = false
            }
        }
    }
</script>

<style scoped="scoped">
    .el-dialog__header {
        height: 100px;
        line-height: 50px;
    }

    .el-dialog__body {
        padding: 10px 20px;
    }

    .el-dialog {
        border-radius: 6px;
    }

    .tipList {
        width: 100%;
    }

    /* 保存提示 */
    .tipList p {
        line-height: 25px;
        text-align: left;
    }

    .tipList p:first-child {
        margin-bottom: 20px;
    }
</style>